import React from "react";
import { CampaignForm } from "./CampaignForm";

const CreateCampaignPage: React.FC = () => {
  return (
    <div className="p-4 lg:p-6">
      <div className="mb-4">
        <h2 className="text-base lg:text-lg font-semibold text-gray-900">
          Create Campaign
        </h2>
        <p className="text-xs lg:text-sm text-gray-500">
          Select customers and templates to launch a new campaign.
        </p>
      </div>
      <CampaignForm />
    </div>
  );
};

export default CreateCampaignPage;

